import routeNames from './route-names'

const Search = () => import(/* webpackChunkName: "search" */'@/views/search/Search')

export default {
    path: '/search',
    name: routeNames.SEARCH,
    meta: {title: 'Search'},
    component: Search,
    props: route => ({
        term: route.query.term
    })
}
